module.exports = __webpack_public_path__ + "gaoqing.91b8c0e1.png";